import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/cable_consumer"

export default class extends Controller {
  connect() {
    if (!this.currentRecipientId) return

    this.subscription = consumer.subscriptions.create(
      { channel: "NotificationsChannel" },
      {
        received: (data) => this.renderNotification(data)
      }
    )
  }

  disconnect() {
    this.subscription?.unsubscribe()
    this.subscription = null
  }

  renderNotification(data) {
    const container = data.target ? document.getElementById(data.target) : null
    const alert = document.createElement("div")
    alert.setAttribute("data-controller", "alert")
    alert.setAttribute("data-alert-timeout-value", "15000")
    alert.setAttribute("role", "alert")
    alert.className = `mt-2 alert ${this.alertClass(data.level)} alert-dismissible fade show auto-close`

    const content = [data.title, data.body].filter(Boolean).join(": ")
    alert.append(document.createTextNode(content || "New notification"))

    if (data.url) {
      const link = document.createElement("a")
      link.href = data.url
      link.className = "alert-link ms-2"
      link.textContent = "Open"
      alert.append(link)
    }

    const button = document.createElement("button")
    button.type = "button"
    button.className = "btn-close"
    button.setAttribute("data-bs-dismiss", "alert")
    button.setAttribute("aria-label", "Close")
    alert.append(button)

    ;(container || this.element).prepend(alert)
  }

  alertClass(level) {
    switch (level) {
      case "error":
        return "alert-danger"
      case "warning":
        return "alert-warning"
      case "success":
        return "alert-success"
      default:
        return "alert-primary"
    }
  }

  get currentRecipientId() {
    return document.querySelector('meta[name="current-user-id"]')?.content ||
      document.querySelector('meta[name="current-subject-account-id"]')?.content
  }
}
